import { COST_FORMATTING, CURRENCY_CODES_TO_CURRENCY_SYMBOLS } from '../Constants'
import numeral from 'numeral'

// We have two formattting methods here as there is an inconsistency in how costs are stored within the system

// This method should be used for costs pertaining to the event itself, i.e. budget.
export const formatCost = (currencyCode: string, cost: number): string => {
  const currencySign = CURRENCY_CODES_TO_CURRENCY_SYMBOLS[currencyCode]
  return `${currencySign}${numeral(cost).format(COST_FORMATTING)}`
}

// This method should be used for costs pertaining to a proposal
export const formatCents = (currencyCode: string, cents: number): string => {
  const currencySign = CURRENCY_CODES_TO_CURRENCY_SYMBOLS[currencyCode]
  return `${currencySign}${numeral(cents / 100).format(COST_FORMATTING)}`
}
